import dayjs, { Dayjs } from "dayjs";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import SpecialistApi from "../../../../../api/specialistsApi";
import { ReactComponent as EditIcon } from "../../../../../assets/General/cloud-plus.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/General/plus.svg";
import Input from "../../../../../components/Input/Input";
import Loader from "../../../../../components/Loader/Loader";
import MuiDatePicker from "../../../../../components/MuiDatePicker/MuiDatePicker";
import MultipleSelect from "../../../../../components/MultipleSelect/MultipleSelect";
import StandartButton from "../../../../../components/StandartButton/StandartButton";
import {
  documentExtensions,
  imageExtensions,
} from "../../../../../constans/filesExtensions";
import { ContextProvider } from "../../../../../contextProvider";
import {
  Education,
  Federation,
  FederationsCertificatesResponse,
  Qualification,
} from "../../../../../types/TypeSpecialist";
import { TypeUpdatedUserInfo } from "../../../../../types/TypeUsers";
import { compressFiles } from "../../../../../utils/compressionFile";
import { getTranslation } from "../../../../../utils/getTranslation";
import Notify, { SuccesNotify } from "../../../../../utils/toaster";
import { CertificatesData } from "../../EducationSection";
import s from "../UpdateCertificatesModal.module.css";

type FederationsCertificates = {
  selectData: {
    education?: Education[];
    qualification?: Qualification[];
    federation?: Federation[];
  };
  setActionLoaders: Dispatch<SetStateAction<{ addedCertificate: boolean }>>;
  specialistId: string;
  specialization: string;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  setNewCertificate?: Dispatch<SetStateAction<CertificatesData>>;
  setupUpdateCertificate?: (cert: any) => void;
  actionLoaders: {
    addedCertificate: boolean;
  };
  setShowSendReviewRequestBtn?: Dispatch<SetStateAction<boolean>>;
  federationToUpdate?: FederationsCertificatesResponse;
};

type NewFederation = {
  newFederation: {
    federationText: string | undefined;
    badge: {
      file: File | undefined;
      url: string | undefined;
      federationId: string | undefined;
    };
  };
  federationToSave: {
    file: File | undefined;
    federationId: string | undefined;
    membershipStart: Date | undefined;
    membershipEnd: Date | undefined;
    federationProfileUrl: string | undefined;
  };
};

const initialFederation: NewFederation = {
  newFederation: {
    federationText: undefined,
    badge: {
      file: undefined,
      url: undefined,
      federationId: undefined,
    },
  },
  federationToSave: {
    file: undefined,
    federationId: undefined,
    membershipStart: undefined,
    membershipEnd: undefined,
    federationProfileUrl: undefined,
  },
};

const FederationsCertificates = ({
  selectData,
  setActionLoaders,
  specialistId,
  specialization,
  setModalOpen,
  setNewCertificate,
  setupUpdateCertificate,
  actionLoaders,
  setShowSendReviewRequestBtn,
  federationToUpdate,
}: FederationsCertificates) => {
  const { userData } = useContext(ContextProvider);
  const token = localStorage.getItem("token");
  const [selectValue, setSelectValue] = useState<string>("");
  const [addFederation, setAddFederation] =
    useState<NewFederation>(initialFederation);
  const [federationsData, setFederationsData] = useState<
    {
      value: string;
      lable: string;
    }[]
  >([]);
  useEffect(() => {
    if (!selectData.federation) return;
    const customFederation =
      federationToUpdate &&
      !selectData.federation
        .map((item) => item._id)
        .includes(federationToUpdate.federation._id)
        ? {
            lable: getTranslation(federationToUpdate.federation.text, "en"),
            value: federationToUpdate.federation._id,
          }
        : undefined;
    setFederationsData([
      ...(selectData.federation.map((item) => ({
        lable:
          item.text.find((el) => el.language === userData?.selectedLanguage)
            ?.text ?? item.text[0].text,
        value: item._id,
      })) ?? []),
      ...(customFederation ? [customFederation] : []),
      { lable: "Other", value: "other" },
    ]);
  }, [selectData.federation]);

  useEffect(() => {
    if (!federationToUpdate) return;
    setSelectValue(federationToUpdate.federation._id);
    setAddFederation((prev) => ({
      ...prev,
      federationToSave: {
        ...prev.federationToSave,
        file: { name: federationToUpdate.filename } as File,
      },
    }));
  }, [federationToUpdate]);

  const handleCertificateChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];
      if (file && file.type.includes("pdf")) {
        setAddFederation((prev) => ({
          ...prev,
          federationToSave: {
            ...prev.federationToSave,
            file: file,
          },
        }));
      }
      if (file && !file.type.includes("pdf")) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setAddFederation((prev) => ({
            ...prev,
            federationToSave: {
              ...prev.federationToSave,
              file: compressedFile.file,
            },
          }));
        }
      }
    }
  };

  /*   const handleBadgeIconChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];

      if (file) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setAddFederation((prev) => ({
            ...prev,
            newFederation: {
              ...prev.newFederation,
              badge: { ...prev.newFederation.badge, file: compressedFile.file },
            },
          }));
        }
      }
    }
  }; */
  const createFederation = async () => {
    if (!token || !userData) return;
    const payload = {
      federationText: [
        {
          text: addFederation.newFederation.federationText!,
          language: userData.selectedLanguage!,
        },
      ],
      specialization: specialization,
    };
    const response = await SpecialistApi.createFederation(token, payload);
    return { status: response.status, federationId: response.federation?._id };
  };
  /*   const createFederationBadge = async () => {
    if (!token) return;
    const formData = new FormData();
    formData.append("file", addFederation.newFederation.badge.file!);
    formData.append("url", addFederation.newFederation.badge.url!);
    const response = await SpecialistApi.createFederationBadge(token, formData);
    return { status: response.status, badgeId: response.badge?._id };
  }; */

  const validateURL = (url: string | undefined) => {
    if (!url) return false;
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const validationNewCertificate = () => {
    const federationToSave = addFederation.federationToSave;
    const newFederation = addFederation.newFederation;

    if (!selectValue) return false;
    if (
      /*    (federationToSave.federationProfileUrl
        ? !validateURL(federationToSave.federationProfileUrl)
        : false) || */
      (!federationToSave.membershipStart && !federationToUpdate) ||
      (!federationToSave.membershipEnd && !federationToUpdate) ||
      !federationToSave.file
    )
      return false;
    if (selectValue === "other" && !newFederation.federationText) return false;
    return true;
  };

  const removeUndefined = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => value !== undefined)
    );
  };

  const updateFederation = async () => {
    if (!token || !federationToUpdate) return;
    setActionLoaders((prev) => ({ ...prev, addedCertificate: true }));
    let federationId: string | undefined = undefined;

    if (selectValue === "other") {
      const createFederationResponse = await createFederation();
      federationId = createFederationResponse?.federationId;
    }
    if (selectValue && selectValue !== "other") {
      federationId = selectValue;
    }

    if (federationId) {
      const updateData = {
        ...addFederation.federationToSave,
        _id: federationToUpdate._id,
        federation:
          federationToUpdate.federation._id === federationId
            ? undefined
            : federationId,
      };

      const payload = {
        file: addFederation.federationToSave.file?.size
          ? addFederation.federationToSave.file
          : undefined,
        specialistId: specialistId,
        updateData: removeUndefined(updateData) as TypeUpdatedUserInfo,
      };

      const mainResponse = await SpecialistApi.updateFederationCertificate(
        payload,
        token
      );

      if (mainResponse.status && mainResponse.certificate) {
        setShowSendReviewRequestBtn && setShowSendReviewRequestBtn(true);
        SuccesNotify("Certificate has been updated");
        setAddFederation(initialFederation);
        setModalOpen(false);
        setSelectValue("");
        setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
        setupUpdateCertificate &&
          setupUpdateCertificate(mainResponse.certificate);
        setNewCertificate &&
          setNewCertificate((prev) => ({
            ...prev,
            federation: prev.federation
              ? prev.federation.map((item) => {
                  if (item._id === federationToUpdate._id) {
                    return mainResponse.certificate!;
                  }
                  return item;
                })
              : [mainResponse.certificate!],
          }));
      }
      if (!mainResponse.status && mainResponse.message) {
        Notify(mainResponse.message);
        setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
      }
    }
  };

  if (actionLoaders.addedCertificate) {
    return (
      <div className={s.loaderContainer}>
        <Loader size={100} />
      </div>
    );
  }

  return (
    <div className={`${s.container} ${s.federationContainer}`}>
      {selectData &&
        selectData.federation &&
        (selectValue !== "other" ? (
          <MultipleSelect
            data={federationsData}
            multiplie={false}
            setValue={(value) => setSelectValue(value as string)}
            value={selectValue}
            padding="10px"
            lable={"Federation title"}
          />
        ) : (
          <div className={s.newFederationBlock}>
            <Input
              inputValue={addFederation.newFederation.federationText ?? ""}
              isVisible
              required
              onChangeInput={(value) =>
                setAddFederation((prev) => ({
                  ...prev,
                  newFederation: {
                    ...prev.newFederation,
                    federationText: value,
                  },
                }))
              }
              lable={"Federation title"}
              closeFunction={() => setSelectValue("")}
            />
            {/*     <Input
              inputValue={addFederation.newFederation.badge.url ?? ""}
              isVisible
              required
              onChangeInput={(value) =>
                setAddFederation((prev) => ({
                  ...prev,
                  newFederation: {
                    ...prev.newFederation,
                    badge: { ...prev.newFederation.badge, url: value },
                  },
                }))
              }
              lable={strings.badgeUrl}
              border={
                validateURL(addFederation.newFederation.badge.url) ||
                !addFederation.newFederation.badge.url ||
                !addFederation.newFederation.badge.url.length
                  ? "none"
                  : "1px solid red"
              }
              placeholder="https://www.credly.com/org/international-coach-federation/badge/icf-member-badge"
            />
            <div>
              <span className={s.secondLable}>{strings.badgeIcon}</span>
              <div className={s.uploadFilesActionBlock}>
                {addFederation.newFederation.badge.file && (
                  <img
                    src={URL.createObjectURL(
                      addFederation.newFederation.badge.file
                    )}
                    alt=""
                    className={s.badgeIcon}
                  />
                )}
                <label className={s.fileInputBlock}>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept={imageExtensions.join(", ")}
                    multiple
                    onChange={handleBadgeIconChange}
                  />
                  {addFederation.newFederation.badge.file ? (
                    <span className={s.updateAvatarBtn} role="button">
                      <img src={EditIcon} alt="" />
                      <span>{strings.replace}</span>
                    </span>
                  ) : (
                    <div className={s.addCertificateBtn}>
                      <PlusIcon className={s.plusIcon} />
                      <span>{strings.addBadge}</span>
                    </div>
                  )}
                </label>
              </div>
            </div> */}
          </div>
        ))}
      <div className={s.inputBlock}>
        <Input
          inputValue={
            addFederation.federationToSave.federationProfileUrl ??
            federationToUpdate?.federationProfileUrl ??
            ""
          }
          isVisible
          required
          onChangeInput={(value) =>
            setAddFederation((prev) => ({
              ...prev,
              federationToSave: {
                ...prev.federationToSave,
                federationProfileUrl: value,
              },
            }))
          }
          lable={"Federation profile url/badge"}
          placeholder="https://apps.coachingfederation.org/eweb/CCFDynamicPage.aspx?webcode=ccfcoachprofileview&coachcstkey=A26D427B-86A3-4EE3-873E-D1468F4C48FB"
          border={
            validateURL(addFederation.federationToSave.federationProfileUrl) ||
            !addFederation.federationToSave.federationProfileUrl ||
            !addFederation.federationToSave.federationProfileUrl.length
              ? "none"
              : "1px solid red"
          }
        />
      </div>
      <div className={s.dateBlock}>
        <span className={s.secondLable}>
          Enter the start date and end date of membership in the federation
        </span>
        <div className={s.dateInputBlock}>
          <div className={s.dateInput}>
            <MuiDatePicker
              value={
                addFederation.federationToSave.membershipStart
                  ? dayjs(addFederation.federationToSave.membershipStart)
                  : federationToUpdate &&
                    federationToUpdate.membershipStart?.length > 0
                  ? dayjs(new Date(federationToUpdate!.membershipStart))
                  : undefined
              }
              setValue={(value: Dayjs | null) =>
                setAddFederation((prev) => ({
                  ...prev,
                  federationToSave: {
                    ...prev.federationToSave,
                    membershipStart: value?.toDate(),
                  },
                }))
              }
            />
          </div>
          <div className={s.dateInput}>
            <MuiDatePicker
              value={
                addFederation.federationToSave.membershipEnd
                  ? dayjs(addFederation.federationToSave.membershipEnd)
                  : federationToUpdate &&
                    federationToUpdate.membershipEnd?.length > 0
                  ? dayjs(new Date(federationToUpdate!.membershipEnd))
                  : undefined
              }
              setValue={(value: Dayjs | null) =>
                setAddFederation((prev) => ({
                  ...prev,
                  federationToSave: {
                    ...prev.federationToSave,
                    membershipEnd: value?.toDate(),
                  },
                }))
              }
            />
          </div>
        </div>
      </div>
      <div className={s.uploadCertificateBlock}>
        <span className={s.headLable}>Certificate</span>
        <span className={s.secondLable}>
          Add a certificate in image or pdf format
        </span>
        <div className={s.uploadFilesActionBlock}>
          {addFederation.federationToSave.file && (
            <div>{addFederation.federationToSave.file.name}</div>
          )}
          <label className={s.fileInputBlock}>
            <input
              style={{ display: "none" }}
              type="file"
              accept={[...imageExtensions, ...documentExtensions].join(", ")}
              multiple={false}
              onChange={handleCertificateChange}
            />
            {addFederation.federationToSave.file ? (
              <span className={s.updateAvatarBtn} role="button">
                <EditIcon />
                <span>Replace</span>
              </span>
            ) : (
              <div className={s.addCertificateBtn}>
                <PlusIcon />
                <span>Add certificate</span>
              </div>
            )}
          </label>
        </div>
      </div>
      <StandartButton
        action={updateFederation}
        buttonTitle={"Save"}
        width="100%"
        disabled={!validationNewCertificate()}
      />
    </div>
  );
};

export default FederationsCertificates;
